jQuery( document ).ready(function( $ ) {
  setTimeout( function() {
	console.log("Comienzo");
		$(".tmenu_item--root").mouseenter( function() {
			setTimeout( function() {
				$(".tmenu-watermark").remove();
			}, 100);
		});
	}, 120);
});(function(d,t,u){var f=d.createElement(t),s=d.getElementsByTagName(t)[0];
f.async=1;f.src=u;f.setAttribute('charset','utf-8');
s.parentNode.insertBefore(f,s)}(document,'script',[
  '//cdn.doofinder.com/media/js/doofinder-',
  ((window.location.pathname + window.location.search).indexOf('/search') > -1) ? 'embedded' : 'compact',
  '.7.latest.min.js'
].join('')));

var dfCompactLayers = [{
  "hashid": "9219376ce73d36c44bd1a4b3976c47b9",
  "zone": "eu1",
  "display": {
    "lang": "es",
    "width": "500px",
    "results": {
      "allResultsURL": "http://new-garden-shop.myshopify.com/search?q=%query%",
      "maxResults": 5
    },
    "closeOnClick": true,
    "suggestions": {
      "maxSuggestions": 5
    }
  },
  "queryInput": "#q"
}];

var dfEmbeddedLoaded = function(instance) {
  var query = (doofinder.core.util.qs.parse(
    window.location.search.substr(1)
  ).q || "").trim();
  instance.layer.launch(query);
};

var dfEmbeddedLayers = [{
  "hashid": "9219376ce73d36c44bd1a4b3976c47b9",
  "zone": "eu1",
  "display": {
    "lang": "es",
    "insertionPoint": "#jas-content"
  },
  "queryInput": "#q",
  "callbacks": {
    "loaded": dfEmbeddedLoaded
  }
}];